export const environment = {
  production: false,
  apiUrl: "https://devapi.arihantatf.com/api"
};
